import React from 'react';
import { Button } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
import './FigmaPromoCard.css';

const FIGMA_LINK = 'https://www.figma.com/@solo_cube';

const FigmaLogo = () => (
  <svg width="32" height="32" viewBox="0 0 38 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 28.5C19 23.2533 23.2533 19 28.5 19C33.7467 19 38 23.2533 38 28.5C38 33.7467 33.7467 38 28.5 38C23.2533 38 19 33.7467 19 28.5Z" fill="#1ABCFE"/>
    <path d="M0 47.5C0 42.2533 4.25329 38 9.5 38H19V47.5C19 52.7467 14.7467 57 9.5 57C4.25329 57 0 52.7467 0 47.5Z" fill="#0ACF83"/>
    <path d="M19 0V19H28.5C33.7467 19 38 14.7467 38 9.5C38 4.25329 33.7467 0 28.5 0H19Z" fill="#FF7262"/>
    <path d="M0 9.5C0 14.7467 4.25329 19 9.5 19H19V0H9.5C4.25329 0 0 4.25329 0 9.5Z" fill="#F24E1E"/>
    <path d="M0 28.5C0 33.7467 4.25329 38 9.5 38H19V19H9.5C4.25329 19 0 23.2533 0 28.5Z" fill="#A259FF"/>
  </svg>
);

export const FigmaPromoCard = ({
  presetType, // 'graphic' or 'ui'
  title,
  subtitle = 'Adjust the colors, then export and preview in Figma.',
  figmaLink = FIGMA_LINK,
  onClose,
  onDontShowAgain,
}) => {
  const handleOpenInFigma = () => {
    window.open(figmaLink, '_blank', 'noopener,noreferrer');
    if (onClose) onClose();
  };

  const handleDontShowAgain = () => {
    if (onDontShowAgain) onDontShowAgain();
  };

  const imageClass = presetType === 'ui'
    ? 'figma-promo-card__image figma-promo-card__image--ui'
    : 'figma-promo-card__image figma-promo-card__image--graphic';

  return (
    <div className="figma-promo-card">
      {/* Close button */}
      <div className="figma-promo-card__close-wrapper">
        <Button
          type="ghost"
          size="medium"
          icon={<Icon name="close" size="medium" />}
          onClick={onClose}
          aria-label="Close"
        />
      </div>

      {/* Info section */}
      <div className="figma-promo-card__info">
        <div className="figma-promo-card__logo">
          <FigmaLogo />
        </div>
        <p className="figma-promo-card__title">{title}</p>
        <p className="figma-promo-card__subtitle">{subtitle}</p>
        <div className="figma-promo-card__actions">
          <button
            type="button"
            className="figma-promo-card__button figma-promo-card__button--primary"
            onClick={handleOpenInFigma}
          >
            Open in Figma
          </button>
          <button
            type="button"
            className="figma-promo-card__button figma-promo-card__button--secondary"
            onClick={handleDontShowAgain}
          >
            Don&apos;t show again
          </button>
        </div>
      </div>

      {/* Image section */}
      <div className={imageClass} aria-hidden="true" />
    </div>
  );
};
